import { AlertCircle } from 'lucide-react';
import type { UserItem } from '@/types/userItem';
import { hasOnlyStockPhoto, TIMESTAMP_TIP } from '@/lib/listingEligibility';

/**
 * Canonical "add a real photo to list this" hint — extracted per Convergence
 * Plan Phase 4 so QuickListPopover, QuickPriceEditDialog and ItemFormModal
 * all render the same soft warning (never a hard-disabled control).
 *
 * Backed by `hasOnlyStockPhoto()` in `src/lib/listingEligibility.ts`. That
 * helper currently returns false everywhere (stock-photo listings are
 * allowed), so this component renders nothing today. Left wired so future
 * rule flips only need a one-line change.
 */
export function PhotoRequiredHint({
  item,
}: {
  item: Pick<UserItem, 'images' | 'stock_image_url' | 'proof_images'>;
}) {
  if (!hasOnlyStockPhoto(item)) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-warning/30 bg-warning/10 p-2 text-[11px] leading-snug text-warning">
      <AlertCircle className="w-3 h-3 mt-0.5 shrink-0" />
      <span>{TIMESTAMP_TIP}</span>
    </div>
  );
}
